import { Link } from 'react-router-dom'
import { footerNav } from '../../content/site'

export function SiteFooter() {
  return (
    <footer className="pp-footer">
      <div className="pp-container">
        <div className="pp-footer__grid">
          <div>
            <div className="pp-footer__brand">Perfect Predict</div>
            <p className="pp-footer__tag">
              AI-powered prediction-first trading experience built on trusted MT5
              infrastructure. One trading account. Two ways to trade.
            </p>
            <div style={{ marginTop: '1.25rem' }}>
              <span className="pp-footer__badge">Powered by MT5</span>
            </div>
          </div>

          <div className="pp-footer__col">
            <h3>Product</h3>
            <ul>
              {footerNav.product.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="pp-footer__col">
            <h3>Account</h3>
            <ul>
              {footerNav.account.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="pp-footer__col">
            <h3>Legal</h3>
            <ul>
              {footerNav.legal.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pp-footer__bottom">
          <span>© {new Date().getFullYear()} Perfect Predict. All rights reserved.</span>
          <span>Trading involves risk. Capital may be at risk.</span>
        </div>
      </div>
    </footer>
  )
}
